module.exports = __webpack_public_path__ + "img/0.a34fe756.png";